import { ComponentType } from '@angular/cdk/portal';
import { EmbeddedViewRef, Injectable, TemplateRef } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig, MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export enum NotificationStatus {
  SUCCESS = 'success',
  ERROR = 'error'
}

export class NotificationConfig extends MatSnackBarConfig {
  closeMsg?: string;   // Use 'null' if you want to not allow manual close
  status?: NotificationStatus;
}

const defaultConfig: NotificationConfig = {
  closeMsg: 'X',
  status: NotificationStatus.ERROR,

  // Default values
  duration:           5 * 1000,
  horizontalPosition: 'end',
  verticalPosition:   'top',
  panelClass:         'app-cmn-notification'  // Style is done in the style.scss
};

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(private snackBar: MatSnackBar) {
  }

  notify(config: NotificationConfig): MatSnackBarRef<SimpleSnackBar> {
    const cfg = Object.assign(
      {},
      defaultConfig,
      { panelClass: [defaultConfig.panelClass, config.status ? config.status : defaultConfig.status] },
      config);
    return this.snackBar.open(cfg.announcementMessage, cfg.closeMsg, cfg);
  }

  notifyWithComponent<T>(component: ComponentType<T>, config?: NotificationConfig): MatSnackBarRef<T> {
    const cfg = Object.assign(
      {},
      defaultConfig,
      { panelClass: [defaultConfig.panelClass, config.status ? config.status : defaultConfig.status] },
       config);
    return this.snackBar.openFromComponent(component, cfg);
  }

  notifyWithTemplate(template: TemplateRef<any>, config?: NotificationConfig): MatSnackBarRef<EmbeddedViewRef<any>> {
    const cfg = Object.assign(
      {},
      defaultConfig,
      { panelClass: [defaultConfig.panelClass, config.status ? config.status : defaultConfig.status] },
       config);
    return this.snackBar.openFromTemplate(template, cfg);
  }

  dismissAll() {
    this.snackBar.dismiss();
  }
}
